import api from './api';

// AKM POC §5.15 — Devam Paneli (kart başına ayrı uç; backend v1/attendance-dashboard/*, TA.Read).
// Boş süzgeçler sorgu dizesine girmez (İzin Paneli'nin clean() deseni).
const clean = (params) => {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') out[key] = value;
  });
  return out;
};

const get = (path) => (params) => api.get(`/v1/attendance-dashboard/${path}`, { params: clean(params) });

export const getAttendanceSummary = get('summary');
export const getAttendanceDailyTrend = get('daily-trend');
export const getAttendanceDepartmentBreakdown = get('department-breakdown');
export const getAttendanceLateDistribution = get('late-distribution');
export const getAttendanceTopLate = get('top-late');
export const getAttendanceTopUndertime = get('top-undertime');
export const getAttendanceBradford = get('bradford');
export const getAttendanceWarnings = get('warnings');
